import Api from '../api';
import { Url } from '../../constants/environment';

class AttendanceService extends Api {
  constructor(props) {
    super(props);
  }

  /**
   * @description 최신
   * @returns
   */
  async getMyAttendance() {
    const res = await this.commonAjax(
      'get',
      Url.named,
      `users/attendanceList`,
    );

    return res;
  }

  /**
   * @description Attendance checkin
   * @param {string} greet - Attendance greeting
   * @param {string} gcode - Google reCaptcha response token
   * @returns
   */
  async checkInMyAttendance (greet, gcode) {
    const res = await this.commonAjax(
      'get',
      Url.named,
      `users/attendance`,
      {
        greet,
        gcode,
      },
    );

    return res;
  }

    /**
   * @description 최신
   * @returns
   */
    async getAttendanceGreetingList(payload) {
      const res = await this.commonAjax(
        'get',
        Url.named,
        `users/attendanceGreetingList`, payload
      );
  
      return res;
    }

    /**
     * @description Get attendance config
     * @returns
     */
    async getAttendanceConfig() {
      const res = await this.commonAjax(
        'get',
        Url.named,
        `users/attendanceConfig`
      );

      return res;
    }
}

export default new AttendanceService();
